<template>
<div class="chapter">
<div class="inner_page">
<h1>Content</h1>
<ol>
<li><a href="#/Text/Section0003">Maurice and the Bay Mare</a></li>
<li><a href="#/Text/Section0004">Lost Farm Camp</a></li>
</ol>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?2fd4f388